export default "/assets/images/home-wrecker-modal.9fcfb5faeb38910c.png";